"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Marketplace = /** @class */ (function () {
    function Marketplace(options) {
        if (options === void 0) { options = {}; }
        this.defaultRegion = options.defaultRegion;
        this.defaultCurrencyCode = options.defaultCurrencyCode;
        this.defaultLanguageCode = options.defaultLanguageCode;
        this.defaultTimeZoneName = options.defaultTimeZoneName;
        this.defaultWeightUnitName = options.defaultWeightUnitName;
        this.defaultCharEncoding = options.defaultCharEncoding;
        this.defaultCountryCode = options.defaultCountryCode;
        this.marketplaceName = options.marketplaceName;
        this.ownerCustomerId = options.ownerCustomerId;
        this.primaryDomainName = options.primaryDomainName;
        this.secureDomainName = options.secureDomainName;
    }
    return Marketplace;
}());
exports.default = Marketplace;
